<div
  class="border-s200 flex w-full flex-row flex-wrap items-stretch overflow-visible border-b"
>
  <div
    *ngFor="let tab of tabs; trackBy: trackByTabId"
    class="text-s1 hover:bg-m50 group relative flex min-h-12 min-w-36 max-w-[30rem] flex-shrink-0 cursor-pointer select-none flex-row items-center gap-x-2 px-4 pb-3 pt-4 text-base first:pl-8"
    (click)="onSelect(tab)"
  >
    <div
      *ngIf="tab.chartType"
      class="flex h-6 w-6 flex-shrink-0 items-center justify-center [&_svg]:h-6 [&_svg]:w-6"
      [ngClass]="{
        'text-m600': tab.id === activeTabId,
        'text-s400': tab.id !== activeTabId
      }"
    >
      <m-chart-table-icon
        *ngIf="tab.chartType === chartTypeEnum.Table"
      ></m-chart-table-icon>

      <m-chart-line-icon
        *ngIf="tab.chartType === chartTypeEnum.Line"
      ></m-chart-line-icon>

      <m-chart-bar-icon
        *ngIf="tab.chartType === chartTypeEnum.Bar"
      ></m-chart-bar-icon>

      <m-chart-scatter-icon
        *ngIf="tab.chartType === chartTypeEnum.Scatter"
      ></m-chart-scatter-icon>

      <m-chart-single-icon
        *ngIf="tab.chartType === chartTypeEnum.Single"
      ></m-chart-single-icon>

      <m-chart-pie-icon
        *ngIf="tab.chartType === chartTypeEnum.Pie"
      ></m-chart-pie-icon>

      <m-chart-pivot-table-icon
        *ngIf="tab.chartType === chartTypeEnum.PivotTable"
      ></m-chart-pivot-table-icon>
    </div>

    <button
      type="button"
      class="min-w-0 flex-1 truncate text-left text-[17px] font-medium focus:outline-none"
      [ngClass]="{
        'text-m600': tab.id === activeTabId,
        'text-s500': tab.id !== activeTabId
      }"
      >{{ tab.label }}</button
    >

    <button
      type="button"
      class="text-s400 hover:text-s500 hover:bg-m200 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded focus:outline-none [&_svg]:h-5 [&_svg]:w-5"
      [ngClass]="{
        invisible: tab.id !== activeTabId
      }"
      (click)="onClose($event, tab)"
      [disabled]="tab.id !== activeTabId"
    >
      <m-delete-icon></m-delete-icon>
    </button>

    <span
      *ngIf="tab.id === activeTabId"
      class="bg-m600 absolute bottom-0 left-0 h-[2px] w-full"
    ></span>
  </div>
</div>
